import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withEvents from 'eventBus/withEvents';
import eventBusTypes from 'eventBus/eventBusTypes';

// @material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Button from 'components/CustomButtons/Button';
import NotificationsIcon from '@material-ui/icons/Notifications';

const styles = {
	phantomFooter: {
		display: 'block',
		padding: '20px',
		height: '91px',
		width: '100%',
	},
	footer: {
		backgroundColor: '#F8F8F8',
		borderTop: '1px solid #E7E7E7',
		textAlign: 'center',
		padding: '26px',
		position: 'fixed',
		left: '0',
		bottom: '0',
		height: '91px',
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	sendButtons: {
		marginTop: '0px',
		marginRight: '5px',
		marginBottom: '0px',
		marginLeft: '5px',
		height: '43px',
		fontSize: '12px',
	},
};

class MarketingCreateBroadcastFooter extends Component {
	create = () => {
		this.props.EventBus.dispatchEvent({
			type: eventBusTypes.CREATE_BROADCAST,
		});
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<div className={classes.phantomFooter} />
				<div className={classes.footer}>
					<Button
						color="success"
						size="lg"
						type="button"
						className={classes.sendButtons}
						onClick={this.create}
						disabled={!this.props.isValidForSend}
					>
						<NotificationsIcon />
						Send notification
					</Button>
				</div>
			</div>
		);
	}
}

MarketingCreateBroadcastFooter.propTypes = {
	isValidForSend: PropTypes.bool,
	EventBus: PropTypes.object,
};

export default withEvents(withStyles(styles)(MarketingCreateBroadcastFooter));
